(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plate-viewer"] && !Shopify.designMode) return;
  try {
    
  class PlateViewer extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('[data-pv-stage]');
      if (!this.stage) return;
      this.notes = this.parentElement.querySelector('[data-pv-notes]');
      this.scale = 1; this.x = 0; this.y = 0;
      this.min = 1; this.max = 5;
      this.dragging = false; this.moved = false;
      this.pointers = new Map(); this.pinchStart = 0; this.scaleStart = 1;

      this.addEventListener('pointerdown', this.onDown);
      this.addEventListener('pointermove', this.onMove);
      this.addEventListener('pointerup', this.onUp);
      this.addEventListener('pointercancel', this.onUp);
      this.addEventListener('wheel', this.onWheel, { passive: false });
      this.addEventListener('keydown', this.onKey);

      const reset = this.querySelector('[data-pv-reset]');
      if (reset) reset.addEventListener('click', (e) => { e.stopPropagation(); this.reset(); });

      this.pins = Array.from(this.querySelectorAll('[data-pv-pin]'));
      this.pins.forEach((pin) => {
        pin.addEventListener('click', (e) => { e.stopPropagation(); this.select(pin.dataset.pvPin); });
      });
      this.select('1', false);
      this.apply();
    }

    select(n, focus = true) {
      if (this.notes) {
        this.notes.querySelectorAll('[data-pv-note]').forEach((el) => {
          el.hidden = el.dataset.pvNote !== n;
        });
      }
      this.pins.forEach((p) => p.setAttribute('aria-current', String(p.dataset.pvPin === n)));
      if (focus && this.notes) this.notes.setAttribute('aria-live', 'polite');
    }

    clamp() {
      const w = this.clientWidth, h = this.clientHeight;
      const maxX = 0, maxY = 0;
      const minX = w - w * this.scale, minY = h - h * this.scale;
      this.x = Math.min(maxX, Math.max(minX, this.x));
      this.y = Math.min(maxY, Math.max(minY, this.y));
    }

    apply() {
      this.clamp();
      this.stage.style.transform = 'translate(' + this.x + 'px,' + this.y + 'px) scale(' + this.scale + ')';
      this.pins.forEach((p) => { p.style.transform = 'scale(' + (1 / this.scale) + ')'; });
    }

    reset() { this.scale = 1; this.x = 0; this.y = 0; this.apply(); }

    zoomAt(cx, cy, next) {
      const k = next / this.scale;
      this.x = cx - (cx - this.x) * k;
      this.y = cy - (cy - this.y) * k;
      this.scale = next;
      this.apply();
    }

    onWheel = (e) => {
      e.preventDefault();
      const r = this.getBoundingClientRect();
      const next = Math.min(this.max, Math.max(this.min, this.scale * (e.deltaY < 0 ? 1.12 : 1 / 1.12)));
      this.zoomAt(e.clientX - r.left, e.clientY - r.top, next);
    };

    onDown = (e) => {
      this.pointers.set(e.pointerId, e);
      if (this.pointers.size === 2) {
        const p = Array.from(this.pointers.values());
        this.pinchStart = Math.hypot(p[0].clientX - p[1].clientX, p[0].clientY - p[1].clientY);
        this.scaleStart = this.scale;
        return;
      }
      this.dragging = true; this.moved = false;
      this.lastX = e.clientX; this.lastY = e.clientY;
      this.setPointerCapture(e.pointerId);
    };

    onMove = (e) => {
      if (!this.pointers.has(e.pointerId)) return;
      this.pointers.set(e.pointerId, e);
      if (this.pointers.size === 2 && this.pinchStart) {
        const p = Array.from(this.pointers.values());
        const d = Math.hypot(p[0].clientX - p[1].clientX, p[0].clientY - p[1].clientY);
        const r = this.getBoundingClientRect();
        const cx = (p[0].clientX + p[1].clientX) / 2 - r.left;
        const cy = (p[0].clientY + p[1].clientY) / 2 - r.top;
        const next = Math.min(this.max, Math.max(this.min, this.scaleStart * (d / this.pinchStart)));
        this.zoomAt(cx, cy, next);
        return;
      }
      if (!this.dragging) return;
      const dx = e.clientX - this.lastX, dy = e.clientY - this.lastY;
      if (Math.abs(dx) + Math.abs(dy) > 3) this.moved = true;
      this.x += dx; this.y += dy;
      this.lastX = e.clientX; this.lastY = e.clientY;
      this.apply();
    };

    onUp = (e) => {
      this.pointers.delete(e.pointerId);
      if (this.pointers.size < 2) this.pinchStart = 0;
      this.dragging = false;
    };

    onKey = (e) => {
      const step = 40;
      if (e.key === 'ArrowLeft') { this.x += step; }
      else if (e.key === 'ArrowRight') { this.x -= step; }
      else if (e.key === 'ArrowUp') { this.y += step; }
      else if (e.key === 'ArrowDown') { this.y -= step; }
      else if (e.key === '+' || e.key === '=') { this.scale = Math.min(this.max, this.scale * 1.15); }
      else if (e.key === '-') { this.scale = Math.max(this.min, this.scale / 1.15); }
      else if (e.key === '0') { this.reset(); return; }
      else { return; }
      e.preventDefault();
      this.apply();
    };
  }
  if (!customElements.get('plate-viewer')) customElements.define('plate-viewer', PlateViewer);

  } catch(e) { console.error(e); }
})();
})();
